import ViewQuote from './ViewQuote'

export default ViewQuote
